import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { faHome, faChartLine, faCalendarDays, faDollarSign } from '@fortawesome/free-solid-svg-icons';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class DashboardComponent implements OnInit {
  faHome = faHome;
  faChartLine = faChartLine;
  faCalendarDays = faCalendarDays;
  faDollarSign = faDollarSign;
  tabIndex = 0;

  user: any;
  today = new Date();

  constructor(
    private readonly titleService: Title,
    private readonly userService: UserService,
  ) {
    this.titleService.setTitle("BAER - My Dashboard");
  }

  ngOnInit(): void {
    this.loadUserInfo();
  }

  loadUserInfo() {
    this.userService.getUserProfile().then((user: any) => {
      this.user = user;
      this.tabIndex = 0;
    })
  }

  indexChange(a: any) {
    this.tabIndex = 1;
  }
}
